import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Flex from 'styled-flex-component'

export const FullscreenIcon = styled(Flex)`
  position: absolute;
  top: calc(50% - 2.625rem);
  left: calc(50% - 2.625rem);
  width: 5.25rem;
  height: 5.25rem;
  border-radius: 50%;
  background-color: rgb(0 0 0 / 20%);
`

export const MediaObjectWrapper = styled.div`
  position: relative;
  ${breakpoint('tabletPortrait')`
    ${FullscreenIcon} {
      display: none;
    };
    &:hover {
      ${FullscreenIcon} {
        display: flex;
      };
    };
  `};
`
